// 如何申请模拟交易平台账号
const HowApply = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/how-apply.vue')),
  'SicTask'
)

// 提交平台账号
const SubmitAccount = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/submit-account.vue')),
  'SicTask'
)

// 如何操作模拟游戏
const HowOperate = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/how-operate.vue')),
  'SicTask'
)

// 了解可交易股票
const HowTrade = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/how-trade.vue')),
  'SicTask'
)

// SICP模拟游戏练习
const GoPractice = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/go-practice.vue')),
  'SicTask'
)

// 了解正式比赛交易规则
const UnderstandRules = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/understand-rules.vue')),
  'SicTask'
)

// SIC中国线上正式比赛
const OnlineGame = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/online-game.vue')),
  'SicTask'
)

// SIC中国线上赛排行榜
const RankingList = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/ranking-list.vue')),
  'SicTask'
)
// 备赛SIC美国线上赛
const PreparationEn = r => require.ensure(
  [],
  () => r(require('@/components/sic-task/preparation-en.vue')),
  'SicTask'
)

export default [
  // 如何申请平台账号
  {
    path: '/SicTask/HowApply',
    name: 'SicTask_HowApply',
    component: HowApply
  },
  // 提交平台账号
  {
    path: '/SicTask/SubmitAccount',
    name: 'SicTask_SubmitAccount',
    component: SubmitAccount
  },
  // 如何操作模拟游戏
  {
    path: '/SicTask/HowOperate',
    name: 'SicTask_HowOperate',
    component: HowOperate
  },
  // 了解可交易股票
  {
    path: '/SicTask/HowTrade',
    name: 'SicTask_HowTrade',
    component: HowTrade
  },
  // 前往练习
  {
    path: '/SicTask/GoPractice',
    name: 'SicTask_GoPractice',
    component: GoPractice
  },
  // 了解正式比赛交易规则
  {
    path: '/SicTask/UnderstandRules',
    name: 'SicTask_UnderstandRules',
    component: UnderstandRules
  },
  // SIC中国线上正式比赛
  {
    path: '/SicTask/OnlineGame',
    name: 'SicTask_OnlineGame',
    component: OnlineGame
  },
  // SIC中国线上赛排行榜
  {
    path: '/SicTask/RankingList',
    name: 'SicTask_RankingList',
    component: RankingList
  },
  // 备赛SIC美国线上赛
  {
    path: '/SicTask/PreparationEn',
    name: 'SicTask_PreparationEn',
    component: PreparationEn
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/sic-task.js